module.exports = __webpack_public_path__ + "static/media/Scarf_Red_01.deb7cedb.png";